import { createSetting } from '@shopex/finder'

export const commonDialogActions = [
  { label: '取消', key: 'close', size: 'default' },
  { label: '确定', key: 'save', type: 'primary', size: 'default' }
]

// 类型：图片(图文) / 视频
export const TYPE_OPTIONS = [
  { label: '图文', value: 'image' },
  { label: '视频', value: 'video' }
]

export const tableSetting = (vm) => createSetting({
  search: [
    {
      name: '文章标题',
      key: 'title',
      placeholder: '请输入文章标题名称'
    },
    {
      name: '类型',
      key: 'type',
      type: 'select',
      options: TYPE_OPTIONS,
      clearable: true,
      placeholder: '请选择图片或视频'
    }
  ],
  columns: [
    {
      name: '序号',
      key: 'sort',
      width: 80
    },
    {
      name: 'ID',
      key: 'article_id',
      width: 80
    },
    {
      name: '文件夹路径',
      key: 'folder_path',
      minWidth: 220,
      formatter: (val, row) => val || row.folder_path || row.file_path || row.path || row.link || '-'
    },
    {
      name: '文章标题',
      key: 'title',
      minWidth: 160
    },
    {
      name: '类型',
      key: 'article_type',
      width: 90,
      formatter: (val, row) => {
        const typeVal = val || row.article_type || ''
        return typeVal === 'video' ? '视频' : typeVal === 'image' ? '图文' : typeVal || '-'
      }
    },
    {
      name: '封面图',
      key: 'image_url',
      width: 90,
      render: (h, { row }) => {
        const src = row.image_url
        if (!src) return h('span', '-')
        return h('el-image', {
          props: {
            src,
            fit: 'cover',
            previewSrcList: [src]
          },
          style: {
            width: '56px',
            height: '56px',
            display: 'block'
          }
        })
      }
    },
    {
      name: '排序',
      key: 'sort_action',
      minWidth: 240,
      render: (h, { row }) => {
        const createActionButton = (label, handler, marginRight = '8px') => h('el-button', {
          props: {
            type: 'text',
            size: 'mini'
          },
          style: {
            padding: 0,
            marginRight
          },
          on: {
            click: () => handler(row)
          }
        }, label)

        return h('div', [
          createActionButton('向上', vm.handleMoveUp),
          createActionButton('向下', vm.handleMoveDown),
          createActionButton('置顶', vm.handleMoveTop),
          // createActionButton('取消置顶', vm.handleMoveUnTop, '0')
        ])
      }
    },
    {
      name: '状态',
      key: 'status',
      minWidth: 120,
      render: (h, { row }) => {
        const checked = row.status === true || row.status === 1 || row.status === '1'
        return h('div', {
          class: 'article-shelf-switch-wrap',
          on: {
            click: (e) => e.stopPropagation()
          }
        }, [
          h('el-switch', {
            props: {
              value: checked ? 1 : 0,
              activeValue: 1,
              inactiveValue: 0,
              activeText: '上架',
              inactiveText: '下架'
            },
            on: {
              input: (value) => vm.handleStatusChange(row, value)
            }
          })
        ])
      }
    },
  ],
  actions: [
    {
      name: '新增',
      slot: 'header',
      type: 'button',
      buttonType: 'primary',
      action: {
        handler: () => vm.handleAdd()
      }
    },
    {
      name: '编辑',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: (row) => vm.handleEdit(row[0])
      }
    },
    {
      name: '删除',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: (row) => vm.handleDelete(row[0])
      }
    }
  ]
})
